import { render, staticRenderFns } from "./MapRisk.vue?vue&type=template&id=183490d8&scoped=true&"
import script from "./MapRisk.vue?vue&type=script&lang=js&"
export * from "./MapRisk.vue?vue&type=script&lang=js&"
import style0 from "./MapRisk.vue?vue&type=style&index=0&id=183490d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183490d8",
  null
  
)

export default component.exports